import { technicalSkills, professionalSkills } from "./data";
import { Box, Typography } from "@mui/material";
import React, { useLayoutEffect } from "react";

import "./skills.css";
import "boxicons";

export default function Skills() {
  const isMobile = window.innerWidth <= 768;

  // This is for technical skills
  useLayoutEffect(() => {
    const progressLine = document.querySelectorAll("#progress-line-box-span");

    const observer = new IntersectionObserver(callback);

    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("progress-line-box-span");
        }
      });
    }
    if (progressLine.length) {
      progressLine.forEach((item) => observer.observe(item));
    }
  }, []);

  // This is for professional skills
  useLayoutEffect(() => {
    const circle = document.querySelectorAll("#path");

    const observer = new IntersectionObserver(callback);

    function callback(item) {
      item.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("path");
        } else entry.target.classList.remove("path");
      });
    }
    if (circle.length) {
      circle.forEach((item) => observer.observe(item));
    }
  }, []);

  return (
    <section id="skills">
      <Box className="skills-container">
        {/* technical skills */}
        <Box className="skills-main">
          <Typography variant="h4" className="skill-type" id={!isMobile ? "fromTop" : ""}>
            Tech Stack
          </Typography>

          {technicalSkills.map((skill, index) => (
            <Box key={index} className="skill-item">
              <box-icon color={skill.color} size="md" animation="tada" name={skill.icon} type="logo"></box-icon>
              <Typography variant="body1" className="text-white">
                {skill.name}
              </Typography>
              <Box className="progress-line">
                <span className="css" id="progress-line-box-span" style={{ "--i": skill.proficiency }}></span>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Core Competencies */}
        <Box className="skills-main">
          <Typography variant="h4" className="skill-type sm:text-center" id={!isMobile ? "fromTop" : ""}>
            Core Competencies
          </Typography>
          <Box className="professional-skills">
            {professionalSkills.map((skill, index) => (
              <Box key={index} className="radial-bar">
                <svg viewBox="0 0 200 200" x="0" y="0">
                  <circle className="progress-bar" cx="100" cy="100" r="80" />
                  <circle className="path" id="path" cx="100" cy="100" r="80" style={{ "--fill-offset": skill.dashOffset }} />
                </svg>
                <Typography variant="body2" className="percentage">
                  {skill.proficiency}
                </Typography>
                <Typography variant="body1" className="text">
                  {skill.name}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </section>
  );
}
